import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function getInitials(name?: string | null) {
  if (!name) {
    return "";
  }

  return name
    .split(" ")
    .map((word) => word[0])
    .concat(name[1])
    .join("")
    .substring(0, 2)
    .toUpperCase();
}

/** Deterministic avatar-ish color (FNV-1a hash → hue) for a string key. */
export function generateColorFromString(value: string): string {
  let hash = 0x811c9dc5;
  for (let i = 0; i < value.length; i++) {
    hash ^= value.charCodeAt(i);
    hash = (hash * 0x01000193) | 0;
  }
  const hue = Math.abs(hash) % 360;
  return `hsl(${hue}, 65%, 45%)`;
}

export function pad(num: number, padding: string = "00"): string {
  if (num < 0) {
    return "-" + pad(-num, padding);
  }

  const str = num.toString();

  if (str.length >= padding.length) {
    return str;
  }

  return (padding + str).slice(-padding.length);
}
